module.exports = __webpack_public_path__ + "ax.svg?6f0d8853d0a37016431a9af206fb9708";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ax.svg
// module id = 748
// module chunks = 27